import { render, staticRenderFns } from "./OtherProcedures.vue?vue&type=template&id=58178627"
import script from "./OtherProcedures.vue?vue&type=script&lang=js"
export * from "./OtherProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports